var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"filescontent"},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"0.26rem","text-align":"center"}},[_vm._v(_vm._s(_vm.ExternalArticleTitle))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.ExternalArticleContent)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }